<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M12.7578 2.75C12.8818 4.75997 14.49 6.36723 16.5 6.49121V8.24414C15.2371 8.19014 14.08 7.72978 13.1562 6.98926L12.75 6.66309V12.625C12.75 15.1794 10.6794 17.25 8.125 17.25C5.57068 17.25 3.5 15.1794 3.5 12.625C3.5 10.0706 5.57068 8 8.125 8C8.42445 8 8.71677 8.02975 9 8.08398V9.88574C8.72389 9.79761 8.42983 9.75 8.125 9.75C6.53718 9.75 5.25 11.0372 5.25 12.625C5.25 14.2128 6.53718 15.5 8.125 15.5C9.71282 15.5 11 14.2128 11 12.625V2.75H12.7578Z" 
    fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'SpyderTikTokIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>